import React, { useEffect,  useState } from 'react';
import { getSeqId } from 'df-helpers/dist/get-seq-id';
import { ReactModel } from '../../react-model/react-model';
import { useOnModelChange } from '../hooks/use-on-model-change';
import { LabelInputLinker } from './label-input-linker';

export type HLabelProps<T> = React.LabelHTMLAttributes<any> & {
	children?: any;
	model: ReactModel<T>;
	field?: keyof NonNullable<T>;
	/** Set the component properties when then model changes */
	onModelChange?: (state: T) => void | React.HTMLAttributes<HTMLLabelElement>;

	/** link to this field, so that clicking the label will activate that field, or toggle the checkbox */
	for_field?: keyof T;
	/** The word "ref" is reserved. We have to use ref2 */
	ref2?: { current: HTMLLabelElement | null };
};

export function HLabel<T>({ children, model, field, for_field, ref2, onModelChange, ...props }: HLabelProps<T>) {
	const [id] = useState(() => getSeqId('_seq_label_')); //cannot be called under condition

	var { state } = field ? model.useModel(field as any) : {state:''};
	//create unique id, and then prepare to link to <input>
	if (for_field && model) {
		if (!props.id) {
			props = { ...props, id };
		}
	}
	useEffect(() => {
		if (model && for_field) {
			LabelInputLinker.addLabel(model, for_field as string, id);
		}
	}, []);

	useOnModelChange(model, onModelChange, props);
	if('children' in props){
		state = (props as any).children as any;
	}

	return (
		<label
			{...props}
			ref={ref2}
			// data-model-id={model?.model_id.toString()}
		>
			{state}
			{children}
		</label>
	);
}
